export const LS_KEY_EMAIL_LINK_LOGIN_KEY = "LS_KEY_EMAIL_LINK_LOGIN_KEY";
export const LS_KEY_AFTER_LOGIN_PATH = "LS_KEY_AFTER_LOGIN_PATH";
